// import { Spin } from "antd"
import React from "react"
import { useRoutes } from "react-router-dom"
import ROUTER from "./index"
import { BallTriangle } from "react-loader-spinner"

// ANONYMOUS

const PublicRouters = React.lazy(() => import("src/pages/PublicRouters"))
const SvgViewer = React.lazy(() => import("src/pages/SvgViewer"))
const NotFound = React.lazy(() => import("src/pages/NotFound"))
const Home = React.lazy(() => import("src/pages/ANONYMOUS/Home"))
const LoginPage = React.lazy(() => import("src/pages/ANONYMOUS/LoginPage"))
const RegisterPage = React.lazy(() => import("src/pages/ANONYMOUS/Register"))
const InfoAccount = React.lazy(() => import("src/pages/ANONYMOUS/InfoAccount"))
const HomeBackground = React.lazy(() =>
  import("src/pages/ANONYMOUS/HomeBackground"),
)
const ChatPublic = React.lazy(() => import("src/pages/ANONYMOUS/ChatPublic"))

// USER
const PrivateRoutes = React.lazy(() => import("src/pages/PrivateRoutes"))
const ChangePassword = React.lazy(() => import("src/pages/USER/ChangePassword"))
const ChatCD = React.lazy(() => import("src/pages/ANONYMOUS/HomeBackgroundCD"))

// ADMIN
const ListFile = React.lazy(() => import("src/pages/ADMIN/ListFile"))
const AminRoutes = React.lazy(() => import("src/pages/ADMIN/AminRoutes"))
const UserManagement = React.lazy(() =>
  import("src/pages/ADMIN/UserManagement"),
)
const AiManager = React.lazy(() => import("src/pages/ADMIN/AiManager"))
const ChatAdmin = React.lazy(() => import("src/pages/ADMIN/ChatAdmin"))
const ChatHistory = React.lazy(() => import("src/pages/ADMIN/ChatHistory"))
const Install = React.lazy(() => import("src/pages/ADMIN/Install"))
const UpdateIDE = React.lazy(() => import("src/pages/ADMIN/UpdateIDE"))
const ErrorHistory = React.lazy(() => import("src/pages/ADMIN/ErrorHistory"))

function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          {/* <Spin /> */}
          <BallTriangle
            height={50}
            width={50}
            radius={5}
            color="#01638d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}

const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.QUAN_LY_TAI_LIEU,
        element: (
          <LazyLoadingComponent>
            <ListFile />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_NGUOI_DUNG,
        element: (
          <LazyLoadingComponent>
            <UserManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUAN_LY_AI,
        element: (
          <LazyLoadingComponent>
            <AiManager />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CAI_DAT,
        element: (
          <LazyLoadingComponent>
            <Install />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CAP_NHAT_IDE,
        element: (
          <LazyLoadingComponent>
            <UpdateIDE />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LICH_SU_CHAT,
        element: (
          <LazyLoadingComponent>
            <ChatHistory />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LICH_SU_LOI,
        element: (
          <LazyLoadingComponent>
            <ErrorHistory />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHAT_AI,
        element: (
          <LazyLoadingComponent>
            <ChatAdmin />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.DOI_MAT_KHAU,
        element: (
          <LazyLoadingComponent>
            <ChangePassword />
          </LazyLoadingComponent>
        ),
      },
    ],
  },

  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.CHAT,
        element: (
          <LazyLoadingComponent>
            <HomeBackground />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHAT_AI_PUBLIC,
        element: (
          <LazyLoadingComponent>
            <ChatPublic />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CHATCD,
        element: (
          <LazyLoadingComponent>
            <ChatCD />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <LoginPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_NHAP,
        element: (
          <LazyLoadingComponent>
            <LoginPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY,
        element: (
          <LazyLoadingComponent>
            <RegisterPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT,
        element: (
          <LazyLoadingComponent>
            <InfoAccount />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
